/**
 * @file submission
 * @author WenCe
 * */
import React, {PureComponent} from 'react';
import TopBar from '../../components/TopBar';
import './index.less';

export default class Submission extends PureComponent {
    componentWillMount() {
        if (this.isPC()) {
            location.href = '/forum';
        }
    }

    render() {
        return (
            <div className="submission">
                {!this.isPC()
                    && <div className="top-bar pr">
                        <TopBar typeLeft={false} />
                    </div>}
                <div className="submission-container">
                    <img src={require('../../asset/svg/pic_gaojianfasong.svg')} alt="立即投稿"/>
                    <div className="submission-email">稿件请发送至：zqanquan@baidu.com</div>
                    <div className="submission-btn" onClick={() => location.href = 'mailto:zqanquan@baidu.com'}>
                        立即投稿
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/submission/index.js